module.exports = __webpack_public_path__ + "static/photo-bg-0ffbc8c61cb959e94e3e2a414d835c2e.jpeg";